import * as React from "react";
import type { SVGProps } from "react";
const SvgMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#minus_svg__a)">
      <path
        fill="currentColor"
        d="M21 13H3c-.55 0-1-.45-1-1s.45-1 1-1h18c.55 0 1 .45 1 1s-.45 1-1 1"
      />
    </g>
    <defs>
      <clipPath id="minus_svg__a">
        <path fill="#fff" d="M2 11h20v2H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgMinus;
